import { createFileRoute } from '@tanstack/react-router'
import node, {
  type accountSecurityPageQuery,
} from '#gen/relay/accountSecurityPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute('/_dashboard/$account/settings/security')({
  staticData: { title: 'Security' },
  loader({ context, params }) {
    return context.preload<accountSecurityPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/account/security/account-security-page'),
    'AccountSecurityPage',
  ),
})
